import { DepartmentModel } from '../../masters/add-department/department.model';
import { AddressModel } from 'src/app/masters/add-address/address.model';
import { EmployeeModel } from 'src/app/masters/add-contact/contact.model';

export class OrganismModel {
    
    orgsmId: number;
    compaVaNameEn: string;	
    compaVaEmail1: string;
    compaVaHomepage: string; 
    compaVaMobilePhone1:string;
    orgsmCode: string;
    compaVaWorkPhone: string;
    compaVaWorkFax: string;
    compaNuNumberEmployees:number; 
    orgDepartmentList:DepartmentModel[];
    orgAddressList:AddressModel[];
    orgEmployeeList:EmployeeModel[];
    staRecCode:string;
    leforId:number;
    curcyId:number;
    active:boolean;
    cotryId;
    pctypId;
    pacatId;
    city;
    mobcode;
    workcode;
}